export default function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isTransformer.js
// module id = 286
// module chunks = 1